import { render, staticRenderFns } from "./jianzhang-list.vue?vue&type=template&id=8153146c&scoped=true"
import script from "./jianzhang-list.vue?vue&type=script&lang=js"
export * from "./jianzhang-list.vue?vue&type=script&lang=js"
import style0 from "./jianzhang-list.vue?vue&type=style&index=0&id=8153146c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8153146c",
  null
  
)

export default component.exports